"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shared = _interopRequireDefault(require("../_shared"));

// eslint-disable-next-line import/no-anonymous-default-export
var _default = {
  cssVars: "\n    :root {\n      ".concat(_shared["default"], "\n      --sans-serif:\n        'Open Sans', -apple-system, BlinkMacSystemFont,\n        'avenir next', avenir,\n        helvetica, 'helvetica neue',\n        ubuntu,\n        noto,\n        'segoe ui',\n        arial,\n        sans-serif;\n      --serif: georgia, serif;\n      --code: consolas, monaco, monospace;\n      --black: #000000;\n      --near-black: #1c2833;\n      --navy: #001b44;\n      --dark-blue: #031f73;\n      --pacific-blue: #0093d6;\n      --blue: #3060af;\n      --light-blue: #3455db;\n      --lightest-blue: #417ca5;\n      --outline-blue: #286fad;\n      --alice-blue: #eafaff;\n      --washed-blue: #f2f5f8;\n      --dark-red: #e7040f;\n      --red: #c02f1d;\n      --light-red: #fcdfdc;\n      --orange: #c05717;\n      --dark-orange: #cb4814;\n      --light-orange: #fed4B9;\n      --green: #73b93b;\n      --light-green: #eefcdc;\n      --gold: #ffb700;\n      --yellow: #fcc300;\n      --light-yellow: #fef5d7;\n      --dark-gray: #707c80;\n      --gray: #c1c7c9;\n      --mid-gray: #dadedf;\n      --light-gray: #f8f8f8;\n      --near-white: #f4f4f4;\n      --white: #ffffff;\n    }\n  "),
  name: 'Blinds.com',
  backgroundColor: 'bg-white',
  accordion: {
    accordion: 'ba b--washed-blue shadow-light-1 br2',
    animateContentDisplay: true,
    item: {
      content: 'pa3',
      title: {
        base: {
          heading: {
            wrapper: 'f3',
            text: ''
          },
          normal: {
            wrapper: 'bb b--mid-gray',
            text: ''
          }
        },
        collapsed: 'bg-light-gray',
        expanded: 'bg-white',
        collapsedAlternate: 'bg-white',
        expandedAlternate: 'bg-white',
        padding: 'pa3',
        lastItemClosedStyle: 'bn',
        toggle: {
          color: 'black',
          icon: 'MdExpandMore',
          position: 'right',
          css: {
            collapsed: "\n              transform: rotate(0);\n            ",
            expanded: "\n              transform: rotate(180deg);\n            "
          }
        }
      }
    }
  },
  alert: {
    base: 'ba br3 items-start',
    icons: {
      error: {
        color: 'red',
        vector: 'MdErrorOutline'
      },
      success: {
        color: 'green',
        vector: 'MdCheckCircle'
      },
      warning: {
        color: 'yellow',
        vector: 'MdErrorOutline'
      }
    },
    spacing: 'pa2 pa3-ns mb3',
    types: {
      error: 'near-black b--red bg-light-red',
      primary: 'near-black b--pacific-blue bg-alice-blue',
      secondary: 'near-black b--gray bg-light-gray',
      success: 'near-black b--green bg-light-green',
      warning: 'near-black b--yellow bg-light-yellow'
    },
    typography: 'sans-serif f6 f5-ns'
  },
  avatar: {
    color: 'blue',
    size: '200px'
  },
  badges: [],
  banner: {
    background: 'var(--white)',
    border: '1px solid var(--mid-gray)',
    heading: {
      fontWeight: '700',
      fontSize: '3rem',
      lineHeight: '4.25rem',
      paddingBottom: '10px'
    },
    subHeading: {
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '22px',
      paddingBottom: '25px'
    },
    anchor: {
      padding: '0 5px',
      textDecoration: 'underline',
      textDecorationLine: 'underline',
      color: 'var(--blue)'
    },
    imageBox: {
      borderColor: 'var(--mid-gray)',
      backgroundColor: 'var(--light-gray)'
    },
    imageBoxDragAccept: {
      borderColor: 'var(--green)'
    },
    imageBoxDragReject: {
      borderColor: 'var(--red)'
    },
    imageBoxFocused: {
      borderColor: 'var(--blue)'
    }
  },
  breadcrumbs: {
    delimiter: '‹',
    fontSize: 'f5',
    linkColor: 'blue',
    maxWidth: '1370px',
    isVisible: true
  },
  brightcoveplayer: 'v6wh9Bpou',
  button: {
    base: 'br2',
    hoverBackgroundColor: 'rgba(0, 0, 0, 0.15)',
    scaleOnHover: false,
    sizes: {
      normal: 'ph4 pv3 f5',
      small: 'ph3 pv2 f6'
    },
    disabled: {
      appearance: 'b--gray bg-gray',
      text: 'white',
      outline: {
        appearance: 'b--gray bg-transparent',
        text: 'gray'
      }
    },
    primary: {
      appearance: 'bg-orange b--orange',
      text: 'white',
      outline: {
        appearance: 'bg-transparent b--orange hover-bg-orange hover-white',
        text: 'orange'
      },
      overrides: ''
    },
    secondary: {
      appearance: 'bg-lightest-blue b--lightest-blue',
      text: 'white',
      outline: {
        appearance: 'bg-transparent b--lightest-blue',
        text: 'lightest-blue'
      }
    },
    tertiary: {
      appearance: 'bg-dark-blue b--dark-blue',
      text: 'white',
      outline: {
        appearance: 'bg-transparent b--dark-blue',
        text: 'dark-blue'
      }
    },
    alert: {
      appearance: 'bg-red b--red',
      text: 'white underline',
      outline: {
        appearance: 'bg-transparent b--red',
        text: 'red'
      }
    }
  },
  table: {
    headerCell: 'fw5 dark-blue',
    size: {
      normal: {
        cellSize: 'pa2',
        headerCellSize: 'pa2'
      },
      large: {
        cellSize: 'pa3',
        headerCellSize: 'pa3'
      }
    },
    type: {
      standard: {
        body: 'bb b--mid-gray',
        cell: {
          tachyons: 'bt b--mid-gray',
          css: ''
        },
        row: {},
        rowBgColor: 'bg-white'
      },
      stripes: {
        cell: {
          tachyons: '',
          css: ''
        },
        row: {},
        rowBgColor: 'bg-washed-blue'
      }
    },
    typography: 'sans-serif f5'
  },
  checkbox: {
    checkboxBorderColor: 'gray',
    checkboxBorderRadius: '5px',
    checkboxBorderWidth: '1px',
    checkboxColorChecked: 'lightest-blue',
    checkboxColorDisabled: 'mid-gray',
    checkboxColorHover: 'mid-gray',
    checkboxSize: '22px',
    checkmarkColor: 'white',
    checkmarkPosition: 'left: 8px; top: 4px; width: 5px; height: 10px;',
    fontSize: '16px',
    textColorDisabled: 'gray',
    textLeftOffset: '2rem',
    textTopOffset: '3px'
  },
  configurator: {
    enableMandi: true,
    enablePayPal: true,
    showExternalPromoMessage: false,
    draftBanner: {
      logoName: 'bcom-logo'
    },
    global: "\n      #gcc-site-wrapper {\n        overflow: visible;\n      }\n      body.with-sidebar {\n        #gcc-site-wrapper {\n          overflow: hidden;\n        }\n      }\n      #gcc-site-menu-overlay {\n        z-index: 4;\n      }\n    ",
    choice: {
      border: 'bw2 br3',
      maxWidth: 'mw4'
    },
    choiceContainer: {
      borderRadius: '6px',
      boxShadow: '0px 0px 10px 0px #1c28331a',
      borderWidth: '2px',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '4px',
      paddingBottom: '10px',
      paddingLeft: '5px',
      width: '100%',
      zoomImage: {
        tachyons: 'right-0',
        css: ''
      }
    },
    option: {
      base: 'relative-ns br3-ns bn ba-ns bw2-ns flex-shrink-0',
      dictionaryTermBackgroundColor: 'bg-light-blue',
      dictionaryTermColor: 'near-black',
      dictionaryTermIconColor: 'light-blue',
      image: 'br2',
      selectedIcon: 'light-blue',
      selectedText: 'near-black',
      selectedLabel: 'near-black',
      sizeGroup: 'flex-column',
      showDivider: true,
      title: {
        base: 'f3 fw7 pt3 pr3 ttc',
        border: ''
      }
    },
    price: {
      addsPrice: 'black',
      text: 'red'
    },
    productInfo: {
      price: {
        dimensions: false
      }
    },
    ctaLabelsAlignments: 'justify-between',
    promo: 'red',
    size: {
      showHelpText: false
    },
    summary: {
      background: 'bg-washed-blue',
      border: 'none',
      choiceValue: 'black',
      floatingBar: {
        background: 'bg-navy',
        priceColor: 'white',
        savings: 'green'
      },
      stickyTop: '1rem',
      tableType: 'stripes'
    }
  },
  pip: {
    preview: {
      container: {
        maxWidth: 'max-width: 350px;'
      },
      samples: {
        tachyons: 'dn db-ns'
      },
      visualizer: {
        floatingTopPosition: '6rem'
      },
      selectedSwatch: '',
      selectedSwatchTy: 'bb b--gray ',
      selectedSwatchInfo: 'pl3',
      styledInfo: 'ph3 ph4-l pb4-l',
      priceAndPromo: ''
    },
    productSpecifications: {
      adobeDownloadDisabled: []
    },
    productSummary: {
      howToGetIt: {
        variant: 'dynamic',
        "static": {
          color: 'var(--near-black)'
        }
      },
      howToGetItBorder: {
        border: 'none'
      },
      dimensionDropdowns: {
        showLabelValues: false
      },
      productInstallationCtaViewDisable: false,
      ctaHide: {
        display: 'none'
      }
    },
    productOptions: {
      showSampleOrderAlert: {
        display: 'block'
      }
    },
    productOverview: {
      exchangeDays: 15,
      mustReturnProduct: false,
      exclusiveGuarantee: true
    },
    productGallery: {
      internetNumLabel: 'Internet #'
    }
  },
  contentBox: {
    appearance: 'bg-white br2 shadow-1',
    content: 'f5',
    title: 'f5 bb b--mid-gray'
  },
  dropdown: {
    arrowColor: 'near-black',
    arrowVector: 'arrow',
    borderBottomWidth: '2px',
    borderColor: 'b--mid-gray',
    borderErrorColor: 'b--red',
    borderWidth: '2px',
    borderRadius: 'br2',
    disabledLabel: 'near-black',
    focusBorderColor: 'blue',
    fontWeight: 400,
    label: 'sans-serif'
  },
  formComponents: {
    fontSize: {
      input: '16px',
      label: '16px'
    },
    inputDropdownHeight: {
      normal: '42px',
      small: '37px'
    }
  },
  gallery: {
    showTitle: true,
    caption: "\n    padding-top: 0.25rem;\n    padding-bottom: 1rem;\n    ",
    carousel: 'mb2',
    tabs: {
      active: 'b--orange bb',
      color: 'var(--white)',
      label: 'pb1 mb3',
      icons: {
        IMAGE: 'image',
        VIDEO: 'video-library'
      },
      container: "flex flex-column mb1 pa0",
      overrides: ""
    },
    ratio: {
      height: 4,
      width: 6
    },
    thumbnail: {
      sizePref: 50,
      selected: {
        overlay: 'rgba(0,157,219,.57)'
      },
      wrapper: 'mh2 w-auto flex flex-shrink-0 flex-grow-0',
      remaining: {
        container: 'sans-serif white bg-black-50'
      },
      video: {
        icon: 'video-library',
        container: 'bg-black-50 flex items-center justify-center',
        color: 'var(--white-50)',
        size: 25,
        style: 'Overlay'
      }
    },
    image: {
      wrapper: 'w-100 h-100',
      picture: 'w-100 h-100',
      img: 'w-100'
    },
    modalTabs: 'separate',
    modal: {
      backgroundColor: 'var(--near-black)',
      color: 'white',
      body: 'overflow-y-hidden',
      videoTitle: "ph0 pb2 w-100 f3 fw-5 lh-title flex justify-center",
      content: 'flex flex-row h-100',
      image: {
        wrapper: 'h-100 flex flex-column',
        picture: 'flex',
        img: 'h-auto'
      },
      media: 'w-80 ph3 flex flex-column',
      header: {
        appearance: 'ttu tc pv3 justify-center'
      },
      title: 'w-auto fw7 f6',
      closeButton: 'absolute top-0 right-0 white ma1',
      thumbnail: {
        sizePref: 80,
        scrollSelected: true,
        container: 'w-20 flex flex-column',
        list: 'flex flex-row justify-center pa0 flex-wrap justify-start pr3 mr2 overflow-y-scroll mb5',
        wrapper: 'w3 h3 w-50-l h-auto-l dib flex-l flex-shrink-0-l flex-grow-0-l pa2',
        selected: {
          overlay: 'rgba(3,31,115,.5)'
        }
      }
    }
  },
  globalStyles: "",
  heading: {
    primary: {
      container: null,
      text: 'fw7'
    },
    font: {
      tachyons: {
        h1: 'f1',
        h2: 'f2',
        h3: 'f3',
        h4: 'f4',
        h5: 'f5',
        h6: 'f6',
        h7: 'f7'
      },
      manual: {}
    }
  },
  internalUser: {
    showEmptyCartLink: true
  },
  leadGeneration: {
    getStarted: {
      footerLink: "pointer f6 fw4 orange",
      header: "white w100 flex flex-row items-center pl4 pr4 bg-orange",
      highlighted: "fw7 orange",
      iconContainer: "\n        height: 3em;\n        width: 3em;\n        background-color: var(--orange)",
      phoneNumber: "fw7 ml1 orange",
      accountIcon: {
        color: 'var(--white)',
        size: '3em'
      },
      checkIcon: {
        color: 'var(--green)',
        size: '2em'
      },
      clockIcon: {
        color: 'var(--white)',
        size: '2.25em'
      },
      phoneIcon: {
        color: 'var(--orange)',
        size: '1.75em'
      }
    },
    highlighted: 'fw7 tc w-100 orange',
    howItWorks: {
      list: {
        style: "\n          content: counter(index, decimal);\n          counter-increment: index;\n          background-color: var(--orange);\n          color: var(--white);\n          display: inline-block;\n          position: absolute;\n          height: 1.75em;\n          width: 1.75em;\n          text-align: center;\n          vertical-align: middle;\n          line-height: 1.75em;\n          border-radius: 5em;",
        vertical: "left: 0;",
        horizontal: "top: -2.5em;"
      }
    },
    priceGuide: {
      highlighted: "fw7 f5 i orange"
    },
    verifyAddress: {
      style: 'w-100 bg-light-blue blue',
      locationIcon: {
        color: 'var(--blue)',
        size: '1.25em'
      }
    }
  },
  link: {
    types: {
      anchor: {
        "default": 'no-underline light-blue',
        hover: 'underline'
      },
      'high-visibility': {
        "default": 'b black',
        hover: 'underline',
        icon: {
          code: 'MdChevronRight',
          color: 'blue',
          position: 'after'
        }
      },
      standard: {
        "default": 'no-underline light-blue',
        hover: 'underline'
      },
      remove: {
        "default": 'black no-underline b',
        hover: 'underline',
        icon: {
          code: 'MdClose',
          color: 'red',
          position: 'before'
        }
      }
    }
  },
  modal: {
    settings: {
      footer: false
    },
    borderRadius: 'br2',
    boxShadowCss: '',
    closeButton: 'hover-bg-light-gray hover-blue blue',
    content: {
      appearance: 'pb3 ph3',
      withTitle: 'pa3'
    },
    header: {
      appearance: 'pa2',
      withTitle: 'bb b--mid-gray'
    },
    overlayColorRgba: 'rgba(0,0,0,.8)',
    title: 'fw5 f5 h2-ns ml2 pr2'
  },
  newsletterSignUp: {
    _settings: {
      defaultMode: 'light'
    },
    content: {
      cta: 'Subscribe',
      prefix: undefined,
      suffix: undefined,
      titleLine1: 'Sign Up & Save an Extra $20',
      titleLine2: 'on orders of $159 or greater.'
    },
    color: {
      dark: {
        text: 'white'
      },
      light: {
        text: 'near-black'
      }
    },
    design: {
      container: 'w-100 mw6',
      title: 'f4'
    }
  },
  orangePay: {
    cssStylesOverrides: "\n      .flex-container {\n        font-family: 'Open Sans', Arial, Helvetica, sans-serif;\n        padding: 0;\n      }\n      @media screen and (max-width: 375px) {\n        .flex-container .cc-expdate-cvv-wrapper {\n          display: block;\n        }\n        .form-input__security-code {\n          margin: 20px 0px;\n        }\n        .flex-container .form-input {\n          width: 90%;\n        }\n        .expiration-date {\n          width: 90%;\n        }\n      }\n      @media screen and (min-width: 641px) {\n        .payment-fields {\n          border-radius: 6px;\n          border: 2px solid #DADEDF;\n          margin-bottom: 0px;\n          padding-right: 5px;\n        }\n        .payment-fields.focus {\n          border-color: #3060AF;\n          border-width: 2px;\n          border-bottom: 2px solid #3060AF;\n        }\n        .form-input__label {\n          margin-bottom: 8px;\n        }\n        .form-input--error .card-number-input {\n          border: 2px solid #C02F1D;\n          border-radius: 6px;\n        }\n        .exclamation {\n          background: url(\"data:image/svg+xml;utf8,%3Csvg fill='black' height='20' width='20' viewBox='0 0 286.054 286.054' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23C02F1D%3B' d='M143.027,0C64.04,0,0,64.04,0,143.027c0,78.996,64.04,143.027,143.027,143.027c78.996,0,143.027-64.022,143.027-143.027C286.054,64.04,222.022,0,143.027,0z M143.027,259.236c-64.183,0-116.209-52.026-116.209-116.209S78.844,26.818,143.027,26.818s116.209,52.026,116.209,116.209S207.21,259.236,143.027,259.236z M143.036,62.726c-10.244,0-17.995,5.346-17.995,13.981v79.201c0,8.644,7.75,13.972,17.995,13.972c9.994,0,17.995-5.551,17.995-13.972V76.707C161.03,68.277,153.03,62.726,143.036,62.726z M143.036,187.723c-9.842,0-17.852,8.01-17.852,17.86c0,9.833,8.01,17.843,17.852,17.843s17.843-8.01,17.843-17.843C160.878,195.732,152.878,187.723,143.036,187.723z' /%3E%3C/svg%3E\") no-repeat 100% center border-box;\n          width: 25px;\n          height: 25px;\n          position: absolute;\n          right: 10px;\n          top: 37px;\n        }\n        #card-number img {\n          top: 30px;\n          height: 38px;\n        }\n        #full-name-input, #card-number-input {\n          margin-bottom: 0px;\n          padding-bottom: 8px;\n        }\n        #security-code-input .form-controls {\n          margin-top: 0px;\n        }\n        #security-code-input, #expiration-date-input {\n          margin-bottom: 0px;\n          margin-top: 10px;\n          padding-bottom: 8px;\n        }\n        #security-code-input label {\n          margin-bottom: 5px;\n        }\n        #expiration-date-input .exclamation {\n          right: 15px;\n        }\n      }\n      .form-input__field {\n        border: 2px solid #DADEDF;\n        border-radius: 6px;\n      }\n      .form-input__field:focus {\n        border-color: #3060AF;\n        border-width: 2px;\n      }\n      .form-input--error .form-input__field {\n        border: 2px solid #C02F1D;\n        border-radius: 6px;\n        background-image: url(\"data:image/svg+xml;utf8,%3Csvg fill='black' height='20' width='20' viewBox='0 0 286.054 286.054' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23C02F1D%3B' d='M143.027,0C64.04,0,0,64.04,0,143.027c0,78.996,64.04,143.027,143.027,143.027c78.996,0,143.027-64.022,143.027-143.027C286.054,64.04,222.022,0,143.027,0z M143.027,259.236c-64.183,0-116.209-52.026-116.209-116.209S78.844,26.818,143.027,26.818s116.209,52.026,116.209,116.209S207.21,259.236,143.027,259.236z M143.036,62.726c-10.244,0-17.995,5.346-17.995,13.981v79.201c0,8.644,7.75,13.972,17.995,13.972c9.994,0,17.995-5.551,17.995-13.972V76.707C161.03,68.277,153.03,62.726,143.036,62.726z M143.036,187.723c-9.842,0-17.852,8.01-17.852,17.86c0,9.833,8.01,17.843,17.852,17.843s17.843-8.01,17.843-17.843C160.878,195.732,152.878,187.723,143.036,187.723z' /%3E%3C/svg%3E\");\n        background-position: calc(100% - 10px) 50%;\n        background-repeat: no-repeat;\n        margin-bottom: 0px;\n      }\n      .form-input__label {\n        margin-bottom: 5px;\n      }\n      .form-input__label::after {\n        margin-left: 2px;\n        content: \"*\";\n        color: #C02F1D;\n      }\n      .form-input__security-code input {\n        margin-top: 5px;\n      }\n      .form-input__security-code label span:before {\n        margin-left: 2px;\n        font-size: 160%;\n        color: #C02F1D;\n        content: \"*\";\n      }\n      .form-input--error .form-input-error__message {\n        font-size: 14px;\n        color: #C02F1D;\n      }\n      .form-input.form-input__cc {\n        margin-bottom: 15px;\n      }\n      .form-input.form-input__cc img {\n        top: 34px;\n      }\n      .form-input__security-code img {\n        top: 34px;\n      }\n      .form-input__security-code .small-font{\n        font-size: 16px;\n      }\n      .form-input__label .small-font{\n        font-size: 16px;\n      }\n      .form-input__security-code label span:before {\n        font-size: 16px;\n        color: #C02F1D;\n      }\n      .drop-down__title {\n        border: 2px solid #DADEDF;\n        border-radius: 6px;\n      }\n      .drop-down__title.drop-down__title--select:focus-within {\n        border-color: #3060AF;\n        border-radius: 6px;\n        background: none;\n      }\n      .drop-down__title.drop-down__title--error {\n        border: 2px solid #C02F1D;\n        border-radius: 6px;\n        background: none;\n      }\n      .drop-down__label {\n        padding-bottom: 5px;\n      }\n      .drop-down__label::after {\n        margin-left: 2px;\n        content: \"*\";\n        color: #C02F1D;\n      }\n      .drop-down__title:before {\n        content: \"\";\n      }\n      .drop-down__title:after {\n        background-image: url(\"data:image/svg+xml;utf8,%3Csvg fill='black' height='24' width='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 10l5 5 5-5z' /%3E%3Cpath d='M0 0h24v24H0z' fill='none' /%3E%3C/svg%3E\");\n        background-position: right 40%;\n        background-repeat: no-repeat;\n      }\n      .expiration-date .drop-down-error__message{\n        font-size: 14px;\n        margin-top: 0px;\n        color: #C02F1D;\n      }\n    ",
    borderWidth: '1px',
    formPaddingBottom: '2rem',
    formPaddingTop: '2rem',
    formMarginBottom: '0px',
    legendWeight: 'fw4',
    titleVisibility: 'visible'
  },
  price: {
    color: 'near-black',
    currency: '$',
    displayOrder: {
      prefix: 1,
      price: 4,
      promo: 2,
      suffix: 6,
      promoDesc: 7,
      promoSavings: 3,
      stackable: 5
    },
    prefix: '',
    promo: 'flex w-100',
    savingsColor: 'red',
    strikethroughColor: 'gray',
    suffix: '',
    superscriptCents: false,
    superscriptCurrency: false,
    showCentsDelimiter: true,
    priceFontSizeSmall: 'f3'
  },
  quantity: {
    backgroundColor: 'bg-white',
    borderColor: 'b--mid-gray',
    borderRadius: 'br2',
    borderWeight: '',
    componentType: ''
  },
  radioButton: {
    radioButtonBackgroundColor: 'white',
    radioButtonBackgroundColorChecked: 'lightest-blue',
    radioButtonBorderColor: 'gray',
    radioButtonBorderColorChecked: 'lightest-blue',
    radioButtonBorderWidth: '1px',
    radioButtonColorChecked: 'white',
    radioButtonColorDisabled: 'mid-gray',
    radioButtonColorHover: 'mid-gray',
    radioButtonSize: '20px',
    radioButtonColor: 'white',
    textColorDisabled: 'gray',
    textLeftOffset: '2rem',
    textTopOffset: '3px'
  },
  rightRailFlyout: {
    enabled: false,
    squareWidth: 55
  },
  selectionBox: {
    choiceSelectionBox: false,
    imageSelectionBox: false,
    borderColor: 'light-gray',
    borderColorSelected: 'lightest-blue',
    borderRadius: 'br3',
    borderWidth: 'bw1',
    checked: {
      base: 'br-pill white absolute z-1',
      container: '',
      overrides: "\n        width: 30px;\n        height: 30px;\n        top: -0.5rem;\n        right: -0.5rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 1.2rem;\n        border: 3px solid var(--white);\n      "
    }
  },
  spinner: {
    color: 'light-blue'
  },
  tag: {
    borderRadius: '.25rem',
    primary: {
      appearance: 'b--gold bg-gold',
      text: 'near-black'
    },
    secondary: {
      appearance: 'b--light-gray bg-light-gray',
      text: 'near-black'
    }
  },
  textInput: {
    borderColor: 'b--mid-gray',
    borderColorFocus: 'b--blue',
    errorColor: 'red',
    borderRadius: 'br2',
    borderWidth: '2px',
    disabledBackground: 'mid-gray',
    disabledLabel: 'near-black sans-serif',
    disabledText: 'dark-gray',
    errorMessageFontSize: '14px',
    label: 'near-black sans-serif',
    showErrorIcon: true
  },
  textInputButton: {
    borderColor: 'b--mid-gray',
    borderRadius: 'br2',
    borderWidth: '2px',
    fontSize: 'f6'
  },
  toggleSwitch: {
    checked: 'var(--green)',
    unchecked: 'var(--gray)'
  },
  visualizer: {
    _settings: {
      actionButtons: 'tertiary'
    },
    buttonColor: 'primary',
    content: {},
    color: {
      zoomOutBackground: 'bg-dark-blue'
    },
    design: {
      fixedTopPosition: {
        large: '1rem',
        medium: '9rem',
        small: '9rem'
      },
      zoomOut: 'br2'
    }
  }
};
exports["default"] = _default;